import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { saveTicketData, uploadFiles } from '../../api';
import styles from './Chats.module.scss';
import { CheckingValidComment, clickTracker } from '../../lib/common';
import CreatedTicketPage from './CreatedTicketPage';

const AttachmentsPage = ({
  setAlert,
  ticketCreateResp,
  selectedSubIssue,
  subIssuesObj,
  selectedIssueVal,
  finalIssuesObj,
}) => {
  const [issueComment, setIssueComment] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const popupRef = useRef(null);
  const storageTicketResp = JSON.parse(sessionStorage.getItem('ticketResp'));
  const ticketId = storageTicketResp?.ticketId || ticketCreateResp?.ticketId;
  const empId = storageTicketResp?.empId || ticketCreateResp?.empId;
  const [finalTicketResp, setFinalTicketResp] = useState('');
  const queryParams = new URLSearchParams(window.location.search);
  const faqPage = queryParams.get('pageType');
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (isPopupVisible && popupRef.current) {
      popupRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [isPopupVisible]);

  const handleCommentSubmit = async () => {
    if (issueComment?.trim().length > 2 && CheckingValidComment(issueComment) && issueComment?.trim()?.length <= 2000) {
      await clickTracker('Update_comment', 'edit_ticket');
      const newComment = { type: 'comment', value: issueComment?.trim() };
      setData((prev) => [...prev, newComment]);
      setIssueComment('');
      setIsPopupVisible(true);
    }
  };

  const handleKeyDown = (evt) => {
    if (evt.key === 'Enter') {
      handleCommentSubmit();
    }
  };
  const handleFileUpload = async (event) => {
    setLoading(true);
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const files = event.target.files ? [...event.target.files] : [];
      if (file && file.size > 5 * 1024 * 1024) {
        setAlert({
          message: 'File exceeds maximum size limit (5 MB). Please upload a smaller file.',
          status: false,
        });
      } else {
        await clickTracker('Update_image', 'Raiseaticket');
        try {
          const response = await uploadFiles(files, true);
          if (response.error_code === 0) {
            if (response.image_urls && response.image_urls.length > 0) {
              const newImage = { type: 'image', name: files[0].name, url: response.image_urls[0] };
              setData((prev) => [...prev, newImage]);
              setIsPopupVisible(true);
            }
          } else {
            setAlert({
              message: 'Invalid file format. Accepted formats - JPEG/JPG/PNG',
              status: false,
            });
          }
        } catch (err) {
          console.log('Error: ', err);
        }
      }
    } else {
      setAlert({
        message: 'Invalid file format. Accepted formats - JPEG/JPG/PNG',
        status: false,
      });
    }
    setLoading(false);
  };
  const handleIsProceedFurther = async (val) => {
    setIsPopupVisible(false);
    if (val === 'Submit') {
      const commentsArr = data.filter((item) => item.type === 'comment').map((item) => item.value);
      const imagesArr = data.filter((item) => item.type === 'image');
      let finalComment = '';
      if (commentsArr?.length > 0) {
        finalComment = commentsArr.join('\n');
      }

      const document = [];
      if (imagesArr?.length > 0) {
        imagesArr?.forEach((item) => {
          document.push({
            nm: item?.name,
            url: item?.url,
          });
        });
      }

      try {
        const params = {
          ticket_id: ticketId || '',
          empid: empId || '',
          sid: '',
          update_data: {
            issue_sub_type:
              selectedIssueVal === 'Others' ? finalIssuesObj?.subIssue : subIssuesObj?.[selectedSubIssue] || '',
          },
        };
        if (finalIssuesObj?.issue) {
          params.update_data.issue_type = finalIssuesObj?.issue;
          if (finalIssuesObj?.issue === 'ECS') {
            params.update_data.vertical = 'RETENTION';
          }
        }

        if (finalComment) {
          params.update_data.issue_comment = finalComment;
        }
        if (document?.length > 0) {
          params.update_data.document = document;
        }
        const res = await saveTicketData(params);
        if (res?.update_flg && res?.update_flg === 1) {
          setFinalTicketResp('success');
        } else {
          setAlert({
            message: 'Something went wrong',
            status: false,
          });
        }
      } catch (err) {
        console.log('Err saving ticket', err);
      }
    }
  };

  const handleDisabledClick = () => {
    setIsError(true);
    setTimeout(() => setIsError(false), 500);
  };
  return (
    <>
      {finalTicketResp ? (
        <div className="p-20 mb-50">
          <CreatedTicketPage
            pageType="final"
            ticketCreateResp={ticketCreateResp || {}}
            selectedIssueVal={selectedIssueVal}
            faqPage={faqPage}
          />
        </div>
      ) : (
        <>
          <div className="p-20 mb-50">
            <div className={`${styles.ExecutiveBox} mb-20`}>
              <div className={`${styles.TextBox}`}>
                <div className={`${styles.ExecutiveIcon} csicon`} />
                <div className={`${styles.ChatText} font14 fw500 color111`}>
                  Thank you for submitting details of your query. You can add your comments and attachments.
                </div>
              </div>
            </div>

            {data &&
              data?.length > 0 &&
              data?.map((item, idx) => (
                <div className={`${styles.UserBox} mb-20`} key={idx}>
                  {item.type === 'comment' ? (
                    <div className={`${styles.UserTxt} font14 fw500 colorFFF`}>{item.value}</div>
                  ) : (
                    <div className={`${styles.UserUploadImgBox}`}>
                      <img alt={item.nm} className={`${styles.UserUploadImg}`} src={item.url} />
                    </div>
                  )}
                </div>
              ))}
            {loading && (
              <div className={`${styles.UserBox}`}>
                <div className={`${styles.UserUploadImgBox}`}>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
                  </div>
                </div>
              </div>
            )}

            {isPopupVisible && (
              <div className={`${styles.ExecutiveBox} mb-50`}>
                <div className={`${styles.TextBox}`}>
                  <div className={`${styles.ExecutiveIcon} csicon`} />
                  <div className={`${styles.ChatText} ${isError ? styles.popupError : ''} font14 fw500 color111`}>
                    If you are done with the details, kindly submit and proceed further
                    <div className={`${styles.ExecutiveBtnGroup}`}>
                      {['Cancel', 'Submit'].map((action, idx) => (
                        <button
                          key={idx}
                          onClick={() => handleIsProceedFurther(action)}
                          type="button"
                          className={`${styles.ExecutiveButton} ${
                            idx === 0 ? 'blue_whitefill_animate' : 'bluefill_animate'
                          }`}
                        >
                          <div className={`font13 fw600 ${idx === 0 ? 'color007' : 'colorFFF'}`}>{action}</div>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div ref={popupRef} />
          <div className={`${styles.ChatFooter}`}>
            {!CheckingValidComment(issueComment) && issueComment && issueComment.length > 3 && (
              <div className="colorEC4 font12 mb-5">Please avoid using special characters.</div>
            )}
            {issueComment && issueComment?.trim()?.length > 2000 && (
              <div className="colorEC4 font12 mb-5">Max comment length reached (2000 characters)</div>
            )}
            <div className={`${styles.FinputGroupBox}`}>
              <div className={`${styles.FinputText}`}>
                <input
                  className={`${styles.Finput} font14 fw400 color111`}
                  type="text"
                  placeholder="Write your comment..."
                  maxLength="10000"
                  value={issueComment}
                  onKeyDown={handleKeyDown}
                  onChange={(e) => setIssueComment(e.target.value)}
                  readOnly={isPopupVisible}
                  onClick={isPopupVisible ? handleDisabledClick : null}
                />
              </div>
              <div className={`${styles.ChatFileIcon} csicon`}>
                <input
                  className={`${styles.FinputFile}`}
                  type="file"
                  accept="image/*"
                  onChange={handleFileUpload}
                  onClick={(e) => {
                    if (isPopupVisible) {
                      e.preventDefault();
                      handleDisabledClick();
                    } else {
                      e.target.value = null;
                    }
                  }}
                  id="file"
                />
              </div>
              <div
                aria-label="comment_submit_btn"
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
                onClick={() => {
                  if (isPopupVisible) {
                    handleDisabledClick();
                  } else {
                    handleCommentSubmit();
                  }
                }}
                className={`${styles.SendIcon} csicon ml-10`}
                style={{
                  backgroundColor:
                    issueComment?.trim().length > 2 &&
                    CheckingValidComment(issueComment) &&
                    issueComment?.trim().length <= 2000
                      ? '#0076d7'
                      : 'gray',
                }}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};
AttachmentsPage.propTypes = {
  setAlert: PropTypes.func,
  ticketCreateResp: PropTypes.object,
  selectedSubIssue: PropTypes.string,
  subIssuesObj: PropTypes.object,
  selectedIssueVal: PropTypes.string,
  finalIssuesObj: PropTypes.object,
};
export default AttachmentsPage;
